
/**
 * Created by Ella Ma on 12/20/19.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class PrintPreviewDashboardService implements OnDestroy {

    openDialog$: Subject<any> = new Subject<any>();

    private _destroySubscriptions: Array<Subscription> = [];

    constructor() { }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    openDialog(name = '', screenType?) {
        this.openDialog$.next({
            isOpen: true,
            name: name,
            screenType: screenType || ''
        });
    }

    closeDialog() {
        this.openDialog$.next({
            isOpen: false,
            name: ''
        });
    }
}
